import CryptoJS from "crypto-js";
import api from '@/constants/api.js'

/**
 * 获取动态密钥
 * @returns {Promise<{key: string, iv: string, visitorstampKey: string}>}
 */
export const getKey = async () => {
    try {
        const res = await api.getKeyApi();
        console.log('getKeyApi响应:', res);
        if(res.data && res.data.success && res.data.data) {
            // 翻转字符串
            const reversedStr = res.data.data.split('').reverse().join('');
            // base64解码
            const decodedStr = atob(reversedStr);
            // 从冒号分割,前面是key,后面是iv
            const [key, iv] = decodedStr.split(':');
            if (!key || !iv) {
                console.error('key或iv为空');
                return null;
            }
            // 返回 key、iv 和时间戳
            return {
                key,
                iv,
                visitorstampKey: res.visitorstampKey
            };
        } else {
            console.error('getKeyApi请求失败:', res);
            return null;
        }
    } catch (err) {
        console.error('getKey-err', err);
        return null;
    }
}

/**
 * AES解密
 * @param {string} word - 待解密的字符串
 * @param {Object|null} keyInfo - 可选的密钥信息对象 {key, iv}，如未提供则自动获取
 * @returns {Promise<Object|null>} 解密后的对象，失败返回null
 */
export const aes_decrypt = async (word, keyInfo = null) => {
    try {
        // 如果没有提供keyInfo，则自动获取
        if (!keyInfo) {
            keyInfo = await getKey();
        }
        
        if (!keyInfo) {
            console.error('获取密钥失败');
            return null;
        }
        
        const key1 = CryptoJS.enc.Utf8.parse(keyInfo.key);
        const iv1 = CryptoJS.enc.Utf8.parse(keyInfo.iv);
        let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
        let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        let decrypt = CryptoJS.AES.decrypt(srcs, key1, {
            iv: iv1,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        
        if (!decryptedStr) {
            console.error('解密失败: 结果为空');
            return null;
        }
        
        const jsonData = decryptedStr.toString() ? JSON.parse(decryptedStr.toString()) : null;
        console.log('解密成功:', jsonData);
        return jsonData || null;
    } catch (err) {
        console.error('aes_decrypt解密异常:', err);
        return null;
    }
};